/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('DOMContentLoaded',function(){
  document.querySelector('div#content-desktop.countries>span').onclick = function(){this.parentElement.classList.toggle('open');}
  document.querySelector('div#content-mobile.countries>span').onclick = function(){this.parentElement.classList.toggle('open');}
});
window.onscroll=()=>{
  if (window.pageYOffset >= window.innerHeight){
    document.querySelector('a#top').classList.add('show');
  } else {
    document.querySelector('a#top').classList.remove('show');
  }
}
Shopify.resizeImage = function(t, r) {
  try {
    if ("original" == r) return t;
    var e = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
    return e[1] + "_" + r + "." + e[2]
  } catch (o) {
    return t
  }
};




window.onload = function(e){ 
  
  setTimeout(function(){
    $('.main-gallery.ProductList').flickity({
      wrapAround: true,
      freeScroll: true,
      lazyLoad: 3,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: false,
      contain: true,
      cellAlign: "center",
      watchCSS: true,
      dragThreshold: 8,
      groupCells: true,
      "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
    });
  },2000);
  
  var $carousel = $('.main-gallery').flickity()
          $carousel.flickity('resize')
          
}


// Sort an array of numbers 
// Sort an array of numbers 
$(document).ready(function(){
  var count = 0,get_i = 0;
  var arr=[], lowestToHighest = [], final_size = [];
  $('.CollectionMain .filter_size li').each(function(){    
    var data_size = $(this).attr('data-size');
    arr.push(data_size);        
  });
  lowestToHighest = arr.sort((a, b) => a - b);
  $(lowestToHighest).each(function(i,v){
    if(!(v == 'a' || v == 'b' || v == 'c' || v == 'd' || v == 's' || v == 's-m'|| v == 'l-xl'|| v == 'xs-s' || v == 'xs' || v == 'xxs' || v == 'l' || v == 'm' || v == 'm-l' || v == 'xs-s'|| v == 'xl' || v == 'xxl')){
      final_size.push(v);
    }
  });  
  if(lowestToHighest.indexOf('a') > -1){
    final_size.push('a');
  }
  if(lowestToHighest.indexOf('b') > -1){
    final_size.push('b');
  }
  if(lowestToHighest.indexOf('c') > -1){
    final_size.push('c');
  }
  if(lowestToHighest.indexOf('d') > -1){
    final_size.push('d');
  }
  if(lowestToHighest.indexOf('xxs') > -1){
    final_size.push('xxs');
  }
  if(lowestToHighest.indexOf('xs') > -1){
    final_size.push('xs');
  }
  if(lowestToHighest.indexOf('s') > -1){
    final_size.push('s');
  }
  if(lowestToHighest.indexOf('m') > -1){
    final_size.push('m');
  }
  if(lowestToHighest.indexOf('l') > -1){
    final_size.push('l');
  }    
  if(lowestToHighest.indexOf('xl') > -1){
    final_size.push('xl');
  }
  if(lowestToHighest.indexOf('xxl') > -1){
    final_size.push('xxl');
  }
  if(lowestToHighest.indexOf('xs-s') > -1){
    final_size.push('xs-s');
  }
  if(lowestToHighest.indexOf('s-m') > -1){
    final_size.push('s-m');
  } 
  if(lowestToHighest.indexOf('m-l') > -1){
    final_size.push('m-l');
  }
  if(lowestToHighest.indexOf('l-xl') > -1){
    final_size.push('l-xl');
  }
  $(final_size).each(function(i,v){  
    $('[data-size = '+ v +']').css('order', i);
  });
});